<template>
  <div class="my-incremental-award">
    <div class="top">
      <div class="desc">
        增量奖预估（元）
        <img src="@/assets/img/my/doubt.png" alt="" @click="showDoubt" />
      </div>
      <div class="amount">
        {{ allIncrementAmount | formatMoney }}
      </div>
    </div>
    <div class="list">
      <div class="header">
        <div>月份</div>
        <div>增量奖预估</div>
        <div>{{ incrementTypeTxt }}T0交易量</div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-if="list && list.length > 0"
          :immediate-check="false"
          @load="queryList"
          v-model="loading"
        >
          <div
            class="body"
            v-for="(item, index) in list"
            :key="index"
            :class="index + 1 < list.length ? 'border-bottom' : ''"
          >
            <div>{{ item.month }}</div>
            <div>{{ item.incrementAmount | formatMoney }}</div>
            <div>{{ item.allAmount | formatMoney }}</div>
          </div>
        </van-list>
        <div v-else class="no-award">
          <img src="@/assets/img/my/noaward-bg.png" alt="" />
          <div class="desc">
            暂无数据
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAllIncrementAmount, getIncrementAmount } from '@/api/my'
import { Dialog } from 'vant'
import { formatMoney } from '@/utils/utils'
export default {
  data() {
    return {
      allIncrementAmount: 0,
      incrementTypeTxt: '',
      list: [],
      pageNo: 1,
      pageSize: 20,
      refreshing: false,
      loading: false,
      finished: false
    }
  },
  filters: {
    formatMoney
  },
  created() {
    getAllIncrementAmount().then(res => {
      this.allIncrementAmount = res.allIncrementAmount || 0
      if (res.type == 1) {
        this.incrementTypeTxt = '电签2.0'
      } else if (res.type == 2) {
        this.incrementTypeTxt = '电签荣耀版'
      }
    })
    this.queryList(true)
  },
  methods: {
    queryList(isFirst) {
      if (isFirst) {
        this.list = []
        this.pageNo = 1
      } else {
        this.pageNo++
      }
      this.loading = true
      if (this.finished) {
        console.log(111)
        this.loading = false
        return
      }
      getIncrementAmount({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(
        res => {
          this.loading = false
          if (this.list.length >= res.incrementList.total) {
            this.finished = true
            return
          }
          let list = res.incrementList.list || []
          console.log('增量奖预估：', res)
          this.list.push(...list)
        },
        err => {
          this.loading = false
        }
      )
    },
    onRefresh() {
      this.finished = false
      this.queryList(true)
      setTimeout(() => {
        this.refreshing = false
      }, 1000)
    },
    showDoubt() {
      Dialog({
        title: '特别声明',
        message: `1、该页面增量奖仅作预估，并非最终增量奖所得
2、因增量奖的特殊计算方式，仅根据上月${this.incrementTypeTxt}的T0交易额进行预估`,
        messageAlign: 'left'
      })
    }
  }
}
</script>
